const checkIfDefault = (value, defaultVal) => {
  if (!value) {
    return defaultVal;
  }
  if ((typeof value === 'string' || value instanceof String) && value.includes('#{REACT_APP_')) {
    return defaultVal;
  }
  return value;
};

const envConfig = {
  ApiUrl: process.env.REACT_APP_API_URL ?? checkIfDefault('#{REACT_APP_API_URL}#', ''),
  ApiKey: process.env.REACT_APP_API_KEY ?? checkIfDefault('#{REACT_APP_API_KEY}#', ''),
  StoragePrefix: process.env.REACT_APP_PREFIX ?? checkIfDefault('#{REACT_APP_PREFIX}#', ''),
  DefaultLanguage: process.env.REACT_APP_DEFAULT_LANGUAGE ?? checkIfDefault('#{REACT_APP_DEFAULT_LANGUAGE}#', ''),
  ContactEmail: process.env.REACT_APP_CONTACT_EMAIL ?? checkIfDefault('#{REACT_APP_CONTACT_EMAIL}#', ''),
  SupportEmail: process.env.REACT_APP_SUPPORT_EMAIL ?? checkIfDefault('#{REACT_APP_SUPPORT_EMAIL}#', ''),
  SiteTitle: process.env.REACT_APP_TITLE ?? checkIfDefault('#{REACT_APP_TITLE}#', ''),
  SiteDescription: process.env.REACT_APP_DESCRIPTION ?? checkIfDefault('#{REACT_APP_DESCRIPTION}#', ''),
  TokenLifetimeHours: process.env.REACT_APP_TOKEN_LIFETIME_HOURS ?? checkIfDefault('#{REACT_APP_TOKEN_LIFETIME_HOURS}#', '24'),
  EncryptionKey: process.env.REACT_APP_ENCRYPTION_KEY ?? checkIfDefault('#{REACT_APP_ENCRYPTION_KEY}#', ''),
  ServerConfigurationString: process.env.REACT_APP_SERVER_CONFIG_STRING ?? checkIfDefault('#{REACT_APP_SERVER_CONFIG_STRING}#', ''),
  HideMenuLocations: ['/register', '/recover', '/reset', '/updatepass'],
  HideHeaderLogo: ['/', '/register', '/recover', '/reset', '/updatepass'],
  Roles: [
    { index: 1, key: 'GlobalAdmin', name: 'global_admin' },
    { index: 2, key: 'Admin', name: 'admin' },
    { index: 3, key: 'CustomerSupport', name: 'customer_support' },
    { index: 4, key: 'OperatorAdmin', name: 'operator_admin' },
    { index: 5, key: 'Finance', name: 'finance' },
    { index: 6, key: 'Analytics', name: 'analytics' },
    { index: 7, key: 'LimitedFinance', name: 'limited_finance' },
    { index: 8, key: 'LimitedAnalytics', name: 'limited_analytics' }
  ],
  BarGraphColor: '#1570ef'
};

export default envConfig;
